export enum HTTPMethod {
    GET = "GET",
    POST = "POST"
}